(function() {
    function initSlKaufAnleitung(section) {
      if (!section) return;

      const buttons = section.querySelectorAll('[data-sl-kauf-image-toggle]');

      buttons.forEach(function(button) {
        if (button.dataset.slKaufReady === 'true') return;
        button.dataset.slKaufReady = 'true';

        button.addEventListener('click', function() {
          if (!button.classList.contains('has-alt-image')) return;

          buttons.forEach(function(otherButton) {
            if (otherButton !== button) {
              otherButton.classList.remove('is-alt-active');
            }
          });

          button.classList.toggle('is-alt-active');
        });
      });
    }

    function initAll(scope) { (scope || document).querySelectorAll('[data-sl-kauf-anleitung]').forEach(initSlKaufAnleitung); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function() { initAll(document); }); else initAll(document);
    document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
  })();
